import styled from "styled-components";

import { useFocusOnButtonRemoval } from "hooks/useFocusOnButtonRemoval";

import { ActionMessageStyleProps, ActionSectionLayoutProps } from "./types";

// Space kept for the message while idle, so the button does not move
const IDLE_MESSAGE_HEIGHT = "30px";

// Message and validate button of a question, shared by Votebox and Quizzbox.
// The live regions stay in the page, even empty, so screen readers announce
// the messages that appear in them (RGAA 7.5). When the button is removed
// after sending, the focus moves to the message (RGAA 12.8).
const ActionSectionLayout = ({
    button,
    isAlertMessage,
    isIdle,
    message,
    messageColor,
    messageTestId,
}: ActionSectionLayoutProps) => {
    const { handleBlur, handleFocus, targetRef } =
        useFocusOnButtonRemoval<HTMLDivElement>(null !== button);

    const idleSpacer = isIdle ? <IdleSpacer /> : null;
    const statusMessage = isIdle || isAlertMessage ? null : message;
    const alertMessage = !isIdle && isAlertMessage ? message : null;

    return (
        <Wrapper onBlur={handleBlur} onFocus={handleFocus}>
            {idleSpacer}
            <Message $color={messageColor} data-testid={messageTestId}>
                <div role="status" ref={targetRef} tabIndex={-1}>
                    {statusMessage}
                </div>
                <div role="alert">{alertMessage}</div>
            </Message>
            {button}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin-top: 1rem;
`;

const IdleSpacer = styled.div`
    height: ${IDLE_MESSAGE_HEIGHT};
`;

const Message = styled.div<ActionMessageStyleProps>`
    color: ${(props) => props.$color};
    width: 100%;
    text-align: center;
`;

export default ActionSectionLayout;
